export default __webpack_public_path__ + "static/media/home-about-meteor-small.f3482d52.png";